import { useUserStore } from '@/store/userStore';

/**
 * Diretiva v-permission
 * 
 * USO:
 * v-permission="'dashboard_producao'"                    - Verifica acesso
 * v-permission="{ app: 'dashboard_producao', perm: 'insert' }" - Verifica permissão específica
 * v-permission:hide="'dashboard_producao'"               - Oculta se não tiver permissão
 * v-permission:disable="'dashboard_producao'"            - Desabilita se não tiver permissão
 */
export const permissionDirective = {
  mounted(el, binding) {
    const userStore = useUserStore();
    
    // IMPORTANTE: Admin também precisa ter permissão configurada no grupo

    let hasPermission = false;
    const { value, arg, modifiers } = binding;

    // Determinar app_name e tipo de permissão
    let appName, permType;
    if (typeof value === 'string') {
      appName = value;
      permType = 'access';
    } else if (typeof value === 'object') {
      appName = value.app;
      permType = value.perm || 'access';
    }

    // Verificar permissão
    hasPermission = userStore.hasPermission(appName, permType);

    // Ações baseadas no modificador
    if (!hasPermission) {
      if (arg === 'hide' || modifiers.hide) {
        // Ocultar elemento
        el.style.display = 'none';
      } else if (arg === 'disable' || modifiers.disable) {
        // Desabilitar elemento
        el.disabled = true;
        el.classList.add('v-btn--disabled');
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.5';
      } else {
        // Padrão: remover do DOM
        el.remove();
      }
    }
  },

  updated(el, binding) {
    // Reaplica a lógica quando o binding muda
    const userStore = useUserStore();
    
    // IMPORTANTE: Admin também precisa ter permissão configurada no grupo

    let hasPermission = false;
    const { value, arg, modifiers } = binding;

    let appName, permType;
    if (typeof value === 'string') {
      appName = value;
      permType = 'access';
    } else if (typeof value === 'object') {
      appName = value.app;
      permType = value.perm || 'access';
    }

    hasPermission = userStore.hasPermission(appName, permType);

    if (!hasPermission) {
      if (arg === 'hide' || modifiers.hide) {
        el.style.display = 'none';
      } else if (arg === 'disable' || modifiers.disable) {
        el.disabled = true;
        el.classList.add('v-btn--disabled');
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.5';
      }
    } else {
      el.style.display = '';
      el.disabled = false;
      el.classList.remove('v-btn--disabled');
      el.style.pointerEvents = '';
      el.style.opacity = '';
    }
  }
};
